import { isEmpty } from 'lodash';

import { OptionItem, SearchQueryInterface, SearchResultTypes } from '@/types';
import { transformCarrierToOptions } from '@/utils/carrier';
import {
  isArrayOfCarrierInterface,
  isArrayOfPlaceInterface,
  isArrayOfVehicleInterface,
} from '@/utils/helpers/type-checks';
import { transformPlacesToOptions } from '@/utils/places';
import { transformVehicleToOptions } from '@/utils/vehicle';

export const parseAdvancedSearchParams = (advancedSearchParams: SearchQueryInterface = {}) => {
  return Object.entries(advancedSearchParams).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      return {
        ...acc,
        [key]: value.map((item) => item.value).join(','),
      };
    }

    return {
      ...acc,
      [key]: value.toString(),
    };
  }, {});
};

// Handle responses, some need shaping, others are ok as is
export const handleSearchQueryResponse = (options: SearchResultTypes): OptionItem[] => {
  if (isEmpty(options)) return [];

  if (isArrayOfPlaceInterface(options)) {
    // Convert Places to Options
    return transformPlacesToOptions(options);
  }

  if (isArrayOfVehicleInterface(options)) {
    // Convert Vehicles to Options
    return transformVehicleToOptions(options);
  }

  if (isArrayOfCarrierInterface(options)) {
    // Convert Carriers to Options
    return transformCarrierToOptions(options);
  }

  return options as OptionItem[];
};
